export const password = {
  meter: {
    background: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    height: "12px",
  },
  icon: {
    color: "{form.field.icon.color}",
  },
  overlay: {
    background: "{overlay.popover.background}",
    borderColor: "{overlay.popover.border.color}",
    borderRadius: "{overlay.popover.border.radius}",
    color: "{overlay.popover.color}",
    padding: "{overlay.popover.padding}",
    shadow: "{overlay.popover.shadow}",
  },
  content: {
    gap: "{gap.4}",
  },
  colorScheme: {
    light: {
      strength: {
        weakBackground: "{color.red.500}",
        mediumBackground: "{color.amber.500}",
        strongBackground: "{color.green.500}",
      },
    },
    dark: {
      strength: {
        weakBackground: "{color.red.400}",
        mediumBackground: "{color.amber.400}",
        strongBackground: "{color.green.400}",
      },
    },
  },
};
